module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Alexander Fullerton\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_vm._v("Alexander Fullerton was a bestselling author of British naval fiction, whose writing career spanned over fifty years. He served with distinction as gunnery and torpedo officer of HM Submarine "), _c('I', [_vm._v("Seadog")]), _vm._v(" during World War Two. He was a fluent Russian speaker, and after the war served in Germany as the Royal Navy liaison with the Red Army. He died in 2008.")], 1)], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/3vbQNw/tc-custom/9781788630368.jpg?1704537868087",
      "alt": "This image is the cover for the book Return to the Field, Rosie Ewing Spy Thrillers"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Return to the Field, Rosie Ewing Spy Thrillers\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("In this stunning adventure set in war-torn France—a British agent finds herself in Nazi territory—and unsure about who to trust . . .")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" It’s the spring of 1944 and Rosie Ewing is returning to German-occupied France, by air, this time."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" She’s carrying a radio, half a million francs, a pistol, and two cyanide capsules to Finistere in north-west Brittany."), _c('br'), _c('br'), _vm._v(" With D-Day looming, Rosie fears that the man who’ll be meeting her on the ground tonight may be a traitor. She can’t be certain. But she does know that the likely end of the road for captured female agents is Ravensbrück, or "), _c('i', [_vm._v("l’enfer des femmes")]), _vm._v(", as the Resistance calls it—the dreaded concentration camp for women . . ."), _c('br'), _c('br'), _c('b', [_vm._v("Praise for the Rosie Ewing Spy Thrillers:")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" “The most meticulously researched war novels I’ve ever read.” —Len Deighton"), _c('br'), _vm._v(" "), _c('br'), _vm._v(" “His action passages are superb.” —"), _c('i', [_vm._v("The Observer")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Canelo Books\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0